export const LogoutRule = {
    "Login":"Login"
};


// WEBPACK FOOTER //
// ./src/BusinessRule/LogoutRule.js